import { useEffect, useRef, useState } from "react";
import { serveAds, api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Serves + tracks one ad for a given slot. Hidden for premium subscribers. */
export default function AdSlot({ slot, channelId, className = "", tall = false }) {
  const [ad, setAd] = useState(null);
  const impressed = useRef(false);
  const { user } = useAuth() || {};

  useEffect(() => {
    if (user?.premium) { setAd(null); return; }
    let mounted = true;
    serveAds(slot, channelId).then(d => {
      if (!mounted) return;
      const ads = (d.ads || []).filter(a => a.slot === slot);
      if (ads.length) setAd(ads[Math.floor(Math.random() * ads.length)]);
    }).catch(()=>{});
    return () => { mounted = false; };
  }, [slot, channelId, user?.premium]);

  useEffect(() => {
    if (ad && !impressed.current) {
      impressed.current = true;
      api.post(`/ads/${ad.id}/impression`).catch(()=>{});
    }
  }, [ad]);

  const onClick = () => { if (ad) api.post(`/ads/${ad.id}/click`).catch(()=>{}); };

  if (!ad) return null;
  return (
    <a href={ad.click_url} onClick={onClick} target="_blank" rel="noopener noreferrer" className={`block relative rounded-xl overflow-hidden border border-[#D4AF37]/25 bg-[#0A0A0E] group ${className}`} data-testid={`ad-slot-${slot}`}>
      <img src={ad.image_url} alt={ad.title} className={`w-full ${tall ? "h-full" : "h-full"} object-cover`} />
      <div className="absolute top-2 left-2 text-[9px] uppercase tracking-widest bg-black/70 text-white/70 px-2 py-0.5 rounded border border-white/10">Sponsored</div>
      <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
        <p className="text-sm font-heading font-semibold text-white">{ad.title}</p>
      </div>
    </a>
  );
}
